import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import DB10030View from "../../Views/Dashboard/DB10030";
import DB10031View from "../../Views/Dashboard/DB10031";
import Snackbar from "../../Components/Snackbar";
import { now } from "moment";
// import "../../Components/Gantt/gantt.scss";

function DB10030(props) {
  const [check, setCheck] = React.useState([]);
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [soDate, setSoDate] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [processData, setProcessData] = React.useState([]);
  const [processCdCheck, setProcessCdCheck] = React.useState(false);
  const [totalProcess, setTotlaProcess] = React.useState("");
  const [process1, setProcess1] = React.useState("");
  const [process2, setProcess2] = React.useState("");
  const [process3, setProcess3] = React.useState("");
  const [process4, setProcess4] = React.useState("");
  const [process5, setProcess5] = React.useState("");
  const [totalProcess1, setTotlaProcess1] = React.useState(
    new Date().getTime()
  );
  let nowProcessTime = new Date().getTime();
  let startDate = [];
  let categories = [];
  const [totalLength, setTotalLength] = React.useState(-1);
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate1, setStartDate1] = React.useState(
    monthAgo.setMonth(today.getMonth() - 3)
  );
  const [modalToggle, setModalToggle] = React.useState(false);
  const [lanData, setLanData] = React.useState([]);
  const [endDate, setEndDate] = React.useState(new Date());
  const [saveSoNo, setSaveSoNo] = React.useState("");
  const [saveItemCd, setSaveItemCd] = React.useState("");
  const [categoriesData, setCategoriesData] = React.useState([]);
  const [seriesData, setSeriesData] = React.useState("");
  const [total, setTotal] = React.useState(0);
  // const [color, setColor] = React.useState([]);
  let color = "";
  const [title, setTitle] = React.useState("");
  //DB10030 그리드 데이터
  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getRowData1 = [];
    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.DataBase.DB10030.GetSalesOrders,
        {
          StartDate: new Date(startDate1),
          EndDate: new Date(endDate),
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              soDt: data[i].soDt
                ? Commons.DateFormating(data[i].soDt.toString(), 2)
                : "",
              soNo: data[i].soNo,
              custNm: data[i].custNm,
              itemNm: data[i].itemNm,
              itemCd: data[i].itemCd,
              soDueDt: data[i].soDueDt
                ? Commons.DateFormating(data[i].soDueDt.toString(), 2)
                : "",
            });
          }
          // setSoDate(getRowData);
          setRowData(getRowData);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const [wkDate, setWkDate] = React.useState([{ name: "", data: [] }]);
  React.useEffect(() => {
    let data = [];
    let qtyList = [];
    let needQtyList = [];
    let wkDataNm = "";
    let saveWkData = [];
    if (
      !soDate ||
      soDate === undefined ||
      soDate === "" ||
      soDate === null ||
      soDate === false ||
      soDate.length === 0
      // !processData ||
      // processData === undefined ||
      // processData === "" ||
      // processData === null ||
      // processData === false ||
      // processData.length === 0
    ) {
    } else {
      // processTime: new Date(data[i].wkStDt).setHours(
      //   new Date(data[i].wkStDt).getHours() + data[i].processTime
      // )
      // new Date(
      //   new Date(soDate[j].wkStDt).setHours(
      //     new Date(soDate[j].wkStDt).getHours() + total
      //   )
      // ).getTime()
      let itemQty = 0;

      for (let i = 0; i < soDate.length; i++) {
        if (i === 1) {
          break;
        }
        wkDataNm = soDate[i] ? soDate[i].itemNm + " 납기일" : "";
        for (let j = i; j < soDate.length; j++) {
          if (i == j) {
            data.push([
              soDate[j] ? soDate[j].soDt : "",
              soDate[j] ? soDate[j].soDueDt : "",
            ]);
            qtyList.push(soDate[j].bomQty);
            needQtyList.push(soDate[j].needQty);
          }
          if (
            soDate[i].woNo !== soDate[j].woNo &&
            soDate[i].bomItemCd === soDate[j].bomItemCd
          ) {
            data.push([
              soDate[j] ? soDate[j].soDt : "",
              soDate[j] ? soDate[j].soDueDt : "",
            ]);
            qtyList.push(soDate[j].bomQty);
            needQtyList.push(soDate[j].needQty);
          }
        }
        saveWkData.push({
          name: wkDataNm,
          data,
          qtyList,
          needQtyList,
        });
        data = [];
        qtyList = [];
        needQtyList = [];
        wkDataNm = soDate[i] ? soDate[i].itemNm + " 총 소요시간" : "";

        for (let j = i; j < soDate.length; j++) {
          if (i == j) {
            data.push([
              soDate[j] ? soDate[j].wkStDt : "",
              soDate[j].compYn === "N"
                ? nowProcessTime
                : soDate[soDate.length - 1].wkEdDt == 0
                ? soDate[soDate.length - 1].wkEdDt
                : soDate[soDate.length - 1].wkEdDt,
            ]);
            qtyList.push(soDate[j].bomQty);
            needQtyList.push(soDate[j].needQty);
          }
          if (
            soDate[i].woNo !== soDate[j].woNo &&
            soDate[i].bomItemCd === soDate[j].bomItemCd
          ) {
            data.push([
              soDate[j] ? soDate[j].soDt : "",
              soDate[j] ? nowProcessTime : "",
            ]);
            qtyList.push(soDate[j].bomQty);
            needQtyList.push(soDate[j].needQty);
          }
        }
        saveWkData.push({
          name: wkDataNm,
          data,
          qtyList,
          needQtyList,
        });

        data = [];
        qtyList = [];
        needQtyList = [];
        let valid = false;
        itemQty = saveWkData[0].data.length;
      }

      for (let i = 0; i < soDate.length; i++) {
        wkDataNm = soDate[i] ? soDate[i].processNm + " 예상시간" : "";
        for (let j = i; j < soDate.length; j++) {
          if (i == j) {
            data.push([
              soDate[j] ? soDate[j].wkStDt : "",
              soDate[j] ? soDate[j].processTime : "",
            ]);

            qtyList.push(soDate[j].bomQty);
            needQtyList.push(soDate[j].needQty);
          }
          if (
            soDate[i].woNo !== soDate[j].woNo &&
            soDate[i].bomItemCd === soDate[j].bomItemCd
          ) {
            data.push([
              soDate[j] ? soDate[j].wkStDt : "",
              soDate[j] ? soDate[j].processTime : "",
            ]);
            qtyList.push(soDate[j].bomQty);
            needQtyList.push(soDate[j].needQty);
          }
        }
        saveWkData.push({
          name: wkDataNm,
          data,
          qtyList,
          needQtyList,
        });
        data = [];
        qtyList = [];
        needQtyList = [];
        wkDataNm = soDate[i] ? soDate[i].processNm + " 소요시간" : "";
        for (let j = i; j < soDate.length; j++) {
          if (i == j) {
            data.push([
              soDate[j] ? soDate[j].wkStDt : "",
              soDate[j]
                ? soDate[j].wkEdDt
                  ? soDate[j].wkEdDt
                  : nowProcessTime
                : "",
            ]);

            qtyList.push(soDate[j].bomQty);
            needQtyList.push(soDate[j].needQty);
          }
          if (
            soDate[i].woNo !== soDate[j].woNo &&
            soDate[i].bomItemCd === soDate[j].bomItemCd
          ) {
            data.push([
              soDate[j] ? soDate[j].wkStDt : "",
              soDate[j]
                ? soDate[j].wkEdDt
                  ? soDate[j].wkEdDt
                  : nowProcessTime
                : "",
            ]);
            qtyList.push(soDate[j].bomQty);
            needQtyList.push(soDate[j].needQty);
          }
        }
        saveWkData.push({
          name: wkDataNm,
          data,
          qtyList,
          needQtyList,
        });
        for (let j = 0; j < itemQty; j++) {
          categories.push(
            soDate[i].itemNm
              ? soDate[i].itemNm.substring(0, soDate[i].itemNm.length / 2) +
                  "<br />" +
                  soDate[i].itemNm.substring(soDate[i].itemNm.length / 2) +
                  "<br />" +
                  new Date(soDate[j].soDueDt).toString().slice(0, 10)
              : ""
          );
        }
        setCategoriesData(categories);
        itemQty = saveWkData[0].data.length;
        i += itemQty - 1;
        data = [];
        qtyList = [];
        needQtyList = [];
        wkDataNm = soDate[i] ? soDate[i].bomItemCd : "";
        let valid = false;
      }

      setWkDate(saveWkData);
      setCheck(wkDate);
    }
  }, [soDate, processData]);

  //tbManuFactureWork데이터
  const GetSoNoData = async (_soNo, _itemCd, _soDueDt) => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getRowData1 = [];
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.DataBase.DB10030.GetDelivery,
        {
          soNo: _soNo ? _soNo : "",
          itemCd: _itemCd ? _itemCd : "",
          soDueDt: _soDueDt ? Commons.DateStrChange(_soDueDt) : "",
        }
      ).then((result) => {
        let data = result.data;
        setTitle(data[0].soNo);
        if (data === "데이터가 없습니다.") {
          setModalToggle(false);
          setSnackbars({
            toggle: true,
            type: "info",
            message: data,
          });
        } else if (data.type === "Error") {
          setModalToggle(false);

          throw new Error(data.message);
        } else {
          setModalToggle(true);

          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              wkStDt: new Date(data[i].wkStDt).getTime(),
              wkEdDt: new Date(data[i].wkEdDt).getTime(),
              soNo: data[i].soNo,
              soDt: new Date(data[i].soDt).getTime(),
              soDueDt: new Date(data[i].soDueDt).getTime(),
              bomItemCd: data[i].bomItemCd,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              processNm: data[i].machineNm,
              processTime: new Date(data[i].wkStDt).setHours(
                new Date(data[i].wkStDt).getHours() + data[i].processTime
              ),
              woNo: data[i].woNo,
              bomQty: data[i].bomQty,
              needQty: data[i].needQty,
            });
            getRowData1.push({
              name: data[i].woNo,
              data: [
                [
                  getRowData[i].wkStDt,
                  getRowData[i].wkEdDt ? getRowData[i].wkEdDt : nowProcessTime,
                ],
              ],
            });
            setSeriesData(getRowData1);
            startDate.push({ processTotalTime: new Date(data[i].wkStDt) });
          }
          setTotalLength(data.length);
          setSoDate(getRowData);
          // GetProc(getRowData[0].itemCd);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  //tbItemBom데이터
  const GetProc = async (_bomItemCd) => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let parsePrNm = "";
    let total1 = 0;
    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.DataBase.DB10030.GetProc,
        {
          itemCd: _bomItemCd ? _bomItemCd : "",
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          for (let i = 0; i < data.length; i++) {
            total1 += data[i].processTime;
            getRowData.push({
              soDt: data[i].soDt,
              soDueDt: data[i].soDueDt,
              soNo: data[i].soNo,
              itemNm: data[i].itemNm,
              // processTime: new Date(
              //   startDate[i].processTotalTime.setHours(
              //     startDate[i].processTotalTime.getHours() + total
              //   )
              // ),
            });
          }
          setTotal(total1);
          // for (let i = 0; i < data.length + 1; i++) {
          //   parsePrNm = data[i - 1].processCd;
          //   categories.push(parsePrNm);
          // }
          setProcessData(getRowData);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <>
      {processCdCheck === false ? (
        <DB10030View
          processCdCheck={processCdCheck}
          setProcessCdCheck={setProcessCdCheck}
          rowData={rowData}
          startDate1={startDate1}
          setStartDate1={setStartDate1}
          endDate={endDate}
          setEndDate={setEndDate}
          Init={Init}
          setSaveItemCd={setSaveItemCd}
          setSaveSoNo={setSaveSoNo}
          GetSoNoData={GetSoNoData}
          lanData={lanData}
        />
      ) : (
        <DB10031View
          processCdCheck={processCdCheck}
          setProcessCdCheck={setProcessCdCheck}
          soDate={soDate}
          setSoDate={setSoDate}
          // series={state.series}
          // options={state.options}
          check={check}
          setCheck={setCheck}
          processData={processData}
          totalProcess={totalProcess}
          process1={process1}
          totalLength={totalLength}
          setProcess1={setProcess1}
          setProcess2={setProcess2}
          setProcess3={setProcess3}
          setProcess4={setProcess4}
          setProcess5={setProcess5}
          setTotlaProcess={setTotlaProcess}
          setProcessData={setProcessData}
          categories={categories}
          categoriesData={categoriesData}
          setCategoriesData={setCategoriesData}
          seriesData={seriesData}
          wkDate={wkDate}
          setWkDate={setWkDate}
          title={title}
          total={total}
        />
      )}
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default DB10030;
